import { render, staticRenderFns } from "./OrderRating.vue?vue&type=template&id=5bfb576c&scoped=true&"
import script from "./OrderRating.vue?vue&type=script&lang=js&"
export * from "./OrderRating.vue?vue&type=script&lang=js&"
import style0 from "./OrderRating.vue?vue&type=style&index=0&id=5bfb576c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfb576c",
  null
  
)

export default component.exports